module.exports = __webpack_public_path__ + "img/wuyou_erjian.d5c87437.png";